"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["BoardNotification"] = 0] = "BoardNotification";
    NotificationType[NotificationType["SlotNotification"] = 1] = "SlotNotification";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
